import React from "react";
import { useDispatch } from "react-redux";

import { IgIconButton } from "@intelligems/ig-theme";
import UndoIcon from "@mui/icons-material/Undo";

import { dispatchExperienceAnalysis } from "../../../../store/slices/ai";

interface BackButtonProps {
  disabled?: boolean;
}
export const BackButton = ({ disabled }: BackButtonProps) => {
  const dispatch = useDispatch();

  return (
    <IgIconButton
      disabled={disabled}
      onClick={() => {
        dispatch(
          dispatchExperienceAnalysis({
            type: "back",
          })
        );
      }}
    >
      <UndoIcon />
    </IgIconButton>
  );
};
